import { createBv } from '@bv/plugins';
import { createPinia } from 'pinia';
import { createApp } from 'vue';

import '@/assets/styles/main.scss';

import messages from '@/locale';
import { mainRoute, modules } from '@/routes';

import App from './App.vue';

const app = createApp(App);

const bv = createBv({
  i18n: { messages },
  pinia: createPinia(),
  layout: 'new',
  mainRoute,
  sidebar: { modules },
});

app.use(bv);

app.mount('#app');
